import { render, staticRenderFns } from "./schoolIndex.vue?vue&type=template&id=52ef9150&scoped=true&"
import script from "./schoolIndex.js?vue&type=script&lang=js&"
export * from "./schoolIndex.js?vue&type=script&lang=js&"
import style0 from "./schoolIndex.vue?vue&type=style&index=0&id=52ef9150&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef9150",
  null
  
)

export default component.exports